export default "__VITE_ASSET__BQp3ScV3__"